const PLAN = {
  variant: "current",
  amountFormatted: "$150K",
  basisLabel: "USD/year",
  startDate: "Jan 26, 2024",
  endDate: "present",
  planReference: "PP-123",
};

const REVIEW_CHANGES = { mode: "buttons", button: "propose-changes", nextEvalDate: "July 1, 2027" };

const person = (firstName, lastName, positionTitle) => ({
  firstName,
  lastName,
  positionTitle,
  avatarUrl: null,
  inactive: false,
});

// Sample rows only: the promotion page never reads or shows account data.
export const FAIR_PAY_PROMO_PREVIEW_ROWS = [
  {
    id: "preview-1",
    department: "Operations",
    employee: person("Olivia", "Rhye", "HR Manager"),
    currentPayPlan: { variant: "no-current" },
    changes: { mode: "buttons", button: "propose-first-pay-plan" },
    fairPayStatus: null,
  },
  {
    id: "preview-2",
    department: "Finance",
    employee: person("Jonathan", "Wiener", "Payroll Assistant"),
    currentPayPlan: PLAN,
    changes: REVIEW_CHANGES,
    fairPayStatus: { status: "above", amount: 18000, currencyCode: "USD", readinessPct: 45 },
  },
  {
    id: "preview-3",
    department: "Engineering",
    employee: person("Maria", "Delgado", "Software Engineer"),
    currentPayPlan: PLAN,
    changes: REVIEW_CHANGES,
    fairPayStatus: { status: "below", amount: 9000, currencyCode: "USD", readinessPct: 45 },
  },
  {
    id: "preview-4",
    department: "Sales",
    employee: person("Carlos", "Mendez", "Sales Executive"),
    currentPayPlan: PLAN,
    changes: {
      mode: "proposal",
      effectiveDate: "Jan 20, 2025",
      summaryLine: "USD · $159K · Annual",
      statusRail: "neutral",
    },
    fairPayStatus: { status: "exact", readinessPct: 45 },
  },
];
